import { render, staticRenderFns } from "./ViewPool.vue?vue&type=template&id=63cf2be1&"
import script from "./ViewPool.vue?vue&type=script&lang=js&"
export * from "./ViewPool.vue?vue&type=script&lang=js&"
import style0 from "./ViewPool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports